<template>
  <el-row class="mb-30" id="invoList">
    <p>
      <span class="head">手动核验发票</span>
    </p>
    <el-table :data="tableData">
      <el-table-column label="发票名称" prop="fileName">
      </el-table-column>
      <el-table-column header-align="center" width="160px">
        <template slot="header">
          <span class="required">*</span>
          <span>
            发票类型
          </span>
        </template>
        <template slot-scope="scope">
          <el-radio-group v-model="scope.row.type" @change="changeType($event, scope.row)">
            <el-radio :label="0">普票</el-radio>
            <el-radio :label="1">专票</el-radio>
          </el-radio-group>
        </template>
      </el-table-column>
      <el-table-column header-align="center">
        <template slot="header">
          <span class="required">*</span>
          <span>
            发票代码
          </span>
        </template>
        <template slot-scope="scope">
          <el-input v-model="scope.row.invoiceCode" placeholder="请输入发票代码"></el-input>
        </template>
      </el-table-column>
      <el-table-column header-align="center">
        <template slot="header">
          <span class="required">*</span>
          <span>
            发票号码
          </span>
        </template>
        <template slot-scope="scope">
          <el-input v-model="scope.row.invoiceNumber" placeholder="请输入发票号码"></el-input>
        </template>
      </el-table-column>
      <el-table-column header-align="center">
        <template slot="header">
          <span class="required">*</span>
          <span>
            开票日期
          </span>
        </template>
        <template slot-scope="scope">
          <el-date-picker
            v-model="scope.row.invoiceDate"
            type="date"
            value-format="yyyy/MM/dd"
            placeholder="请输入开票日期">
          </el-date-picker>
        </template>
      </el-table-column>
      <el-table-column header-align="center">
        <template slot="header">
          <span class="required">*</span>
          <span>
            不含税金额(元)
          </span>
        </template>
        <template slot-scope="scope">
          <el-input v-model="scope.row.amount" placeholder="请输入不含税金额"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="校验码后六位" header-align="center">
        <template slot-scope="scope">
          <el-input v-if="scope.row.type===0" v-model="scope.row.checkCode" placeholder="请输入校验码后六位"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="90px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="verificationTicketDto(scope.row)">核验</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-row>
</template>

<script>
import api from '@/http/merchant/submit'

export default {
  props: {
    contracts: {
      required: false,
      type: Array,
      default() {
        return null
      }
    },
    data: {
      required: false,
      type: Array,
      default() {
        return null
      }
    },
  },
  watch: {
    data() {
      this.tableData = this.data
    }
  },
  mounted() {
    this.tableData = this.data
  },
  data() {
    return {
      tableData: []
    }
  },
  methods: {
    changeType(val, item) {
      if (val === 1) {
        item.checkCode=''
      }
    },
    // 核验
    verificationTicketDto(item) {
      // 检查字段是否都填写完毕
      if (!item.type && item.type !==0) {
        this.$message.warning('请选择发票类型')
        return
      }
      if (!item.invoiceCode) {
        return this.$message.warning('请输入发票代码')
      }
      if (!item.invoiceNumber) {
        return this.$message.warning('请输入发票号码')
      }
      if (!item.invoiceDate) {
        return this.$message.warning('请选择开票日期')
      }
      if (!item.amount) {
        return this.$message.warning('请输入不含税金额')
      }
      if (item.type===0&&!item.checkCode) {
        return this.$message.warning('请输入校验码')
      }
      item.contractCode = this.contracts[0].contractCode
      item.contractName = this.contracts[0].contractName
      item.dataGroupOrgId = this.contracts[0].dataGroupOrgId
      item.domainUserCode = this.contracts[0].domainUserCode
      api.verificationTicket(item).then(res => {
        if (res.code === this.sucCode) {
          const data = res.data
          item.status = 1
          item.result = res.data
          const obj = {
            attachmentUrl: item.attachmentUrl,
            result: res.data,
            status: 1,
            errorMsg: ''
          }
          this.$message.success(`${item.fileName} 核验成功!请注意保存，否则关闭弹框后数据会消失！`)
          this.$emit('success', obj)
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.head {
  font-weight: bold;
  font-size: 14px;
  color: #333;
  line-height: 40px;
}
.required {
  color: red;
}
</style>